export interface IMenuFormValues {
  menuName: string
  linkId: number | null
  link: string
  icon: string
  slNo: number | null
}

export interface IMenu {
  id_menu: number
  parent_id: number
  menu_name: string
  link_id: number
  position: number
  icon: string
  sl_no: number
  is_active: string
  parent: string
}

export const initMenuFormValues: IMenuFormValues = {
  menuName: '',
  linkId: null,
  link: '',
  icon: '',
  slNo: null,
}
